import React from "react";
import "./pageHeader.css";

/**
 * Shared page header for the admin list/detail pages.
 * Renders the Warm Residential heading block (eyebrow + serif title +
 * description) with an optional actions area on the right (search, buttons).
 */
const PageHeader = ({ eyebrow, title, subtitle, actions }) => (
  <header className="sh-page-head sh-rise">
    <div className="sh-page-headings">
      {eyebrow && <p className="sh-page-eyebrow">{eyebrow}</p>}
      <h1 className="sh-page-title">{title}</h1>
      {subtitle && <p className="sh-page-desc">{subtitle}</p>}
    </div>
    {actions && <div className="sh-page-actions">{actions}</div>}
  </header>
);

export default PageHeader;
